import { render } from "./OpenFinanceButton.vue?vue&type=template&id=35c5e8e7&scoped=true"
import script from "./OpenFinanceButton.vue?vue&type=script&lang=js"
export * from "./OpenFinanceButton.vue?vue&type=script&lang=js"

import "./OpenFinanceButton.vue?vue&type=style&index=0&id=35c5e8e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c5e8e7"]])

export default __exports__